import { apiService } from './api.js';

const PROJECTS_BASE = '/projects';

function o2kBase(projectId, filename) {
  return `${PROJECTS_BASE}/${projectId}/files/${encodeURIComponent(filename)}/o2kinetics`;
}

export async function listTransitions(projectId, filename, chamber) {
  const response = await apiService.get(`${o2kBase(projectId, filename)}/transitions`, {
    params: { chamber: String(chamber) },
  });
  return response.data;
}

export async function createTransition(projectId, filename, chamber, payload) {
  const response = await apiService.post(`${o2kBase(projectId, filename)}/transition`, payload, {
    params: { chamber: String(chamber) },
  });
  return response.data;
}

export async function updateTransition(projectId, filename, chamber, payload) {
  const response = await apiService.put(`${o2kBase(projectId, filename)}/transition`, payload, {
    params: { chamber: String(chamber) },
  });
  return response.data;
}

export async function deleteTransition(projectId, filename, chamber, transitionId) {
  const response = await apiService.delete(
    `${o2kBase(projectId, filename)}/transition/${transitionId}`,
    { params: { chamber: String(chamber) } },
  );
  return response.data;
}
